import React, { useState, useCallback, useEffect, useRef } from "react";
import CustomContextMenu from "../SideBar/CustomContextMenu/CustomContextMenu";
import DatabaseCreatePopup from "../SideBar/Popup/DatabaseCreatePopup/DatabaseCreatePopup";
import DatabaseDropPopup from "../SideBar/Popup/DropDatabasePopup/DatabaseDropPopup";
import CreateTablePopup from "../SideBar/Popup/CreateTablePopup/CreateTablePopup";
import ImportDataInTable from "../SideBar/Popup/ImportDataInTable/ImportDataInTable";
import TruncateDataPopup from "../SideBar/Popup/TruncateDataPopup/TruncateDataPopup";
import TableDropPopup from "../SideBar/Popup/DropTablePopup/TableDropPopup";
import AddColumnPopup from "./Popup/AddColumnPopup/AddColumnPopup";
import RemoveColumnPopup from "./Popup/RemoveColumnPopup/RemoveColumnPopup";
import RestoreTablePopup from "../SideBar/Popup/RestoreTablePopup/RestoreTablePopup";
import RestoreDatabasePopup from "../SideBar/Popup/RestoreDatabasePopup/RestoreDatabasePopup";
import RenameTablePopup from "./Popup/RenameItemPopup/RenameTablePopup/RenameTablePopup";
import RenameDatabasePopup from "./Popup/RenameItemPopup/RenameDatabasePopup/RenameDatabasePopup";
import "../SideBar/SideBar.scss";
import DatabaseSection from "./DatabaseSection.js";

import { FcDatabase } from "react-icons/fc";
import { DiDatabase } from "react-icons/di";
import { MdOutlineBackupTable } from "react-icons/md";
import { LuTable2 } from "react-icons/lu";
import CustomModal from "../../../../../common/CustomModal/CustomModal";
import { useResults } from "../../ResultsProvider";
import { GrMysql } from "react-icons/gr";
import { DiMsqlServer } from "react-icons/di";
import { BiLogoPostgresql } from "react-icons/bi";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { toast } from "react-toastify";

import {
  getDatabases,
  addColumnToTable,
  dropColumnFromTable,
  backupDatabase,
  backupTable,
  renameDatabase,
  renameTable,
  restoreTable,
  restoreDatabase,
  createDatabase,
  dropDatabase,
  truncateData,
  getDatabaseType,
  exportTable,
  getTables,
  dropTable,
  viewTableData,
  getColumns,
} from "../../../../../../api/database_gui.js";

const MIN_WIDTH_PX = window.innerWidth * 0.15;
const MAX_WIDTH_PX = window.innerWidth * 0.5;

const SideBar = ({ resourceId, systemUserId, databaseInfo, setDatabaseInfo, selectedDatabase, setSelectedDatabase, triggerQueryRefresh, resourceAccessID }) => {
  const [sectionsOpen, setSectionsOpen] = useState({
    postgres: false,
    databases: false,
    openDatabaseId: null,
    openTables: null,
    openTableId: null,
  });
  const [databaseLinks, setDatabaseLinks] = useState([]);
  const [databaseCount, setDatabaseCount] = useState(null);
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    type: "",
    dbId: null,
    tableName: null,
    columnName: null,
  });
  const [error, setError] = useState(null);
  const [createDatabasePopupVisible, setCreateDatabasePopupVisible] =
    useState(false);
  const [dropDatabasePopupVisible, setDropDatabasePopupVisible] =
    useState(false);
  const [databaseToDrop, setDatabaseToDrop] = useState(null);
  const [formData, setFormData] = useState("");
  const [activeDatabaseId, setActiveDatabaseId] = useState(null);
  const [tableCountsVisible, setTableCountsVisible] = useState({});
  const [activeTable, setActiveTable] = useState(null);
  const [activeColumn, setActiveColumn] = useState(null);
  const [activeTableCount, setActiveTableCount] = useState(null);
  const [isCreateTablePopupVisible, setIsCreateTablePopupVisible] =
    useState(false);
  const [importDataPopupVisible, setImportDataPopupVisible] = useState(false);
  const [importTableName, setImportTableName] = useState("");
  const [truncateDataPopupVisible, setTruncateDataPopupVisible] =
    useState(false);
  const [tableToTruncate, setTableToTruncate] = useState("");
  const [importDatabaseName, setImportDatabaseName] = useState("");
  const [file, setFile] = useState(null);
  const [dropTablePopupVisible, setDropTablePopupVisible] = useState(false);
  const [dropTableName, setDropTableName] = useState(null);
  const [dropTableNameDatabase, setDropTableNameDatabase] = useState("");
  const [renameTablePopupVisible, setRenameTablePopupVisible] = useState(false);
  const [currentTableName, setCurrentTableName] = useState("");
  const [newTableName, setNewTableName] = useState("");
  const [databaseToRenameTable, setDatabaseToRenameTable] = useState(null);
  const [renameDatabasePopupVisible, setRenameDatabasePopupVisible] =
    useState(false);
  const [newDatabaseName, setNewDatabaseName] = useState("");
  const [restoreTablePopupVisible, setRestoreTablePopupVisible] =
    useState(false);
  const [isRenameTablePopupVisible, setIsRenameTablePopupVisible] =
    useState(false);
  const [isRenameDatabasePopupVisible, setIsRenameDatabasePopupVisible] =
    useState(false);
  const [currentDatabaseName, setCurrentDatabaseName] = useState("");
  const [isRestoreTablePopupVisible, setIsRestoreTablePopupVisible] =
    useState(false);
  const [restoreDatabasePopupVisible, setRestoreDatabasePopupVisible] =
    useState(false);
  const [restoreLoading, setRestoreLoading] = useState(false);
  const [tableToRestore, setTableToRestore] = useState(null);
  const [databasetorestoretable, setDatabaseToRestoretable] = useState(null);
  const sidebarRef = useRef(null);
  const menuRef = useRef(null);
  const prevActiveDatabaseIdRef = useRef(null);
  const [databaseToAddTable, setDatabaseToAddTable] = useState(null);
  const [addColumnPopupVisible, setAddColumnPopupVisible] = useState(false);
  const [tableToAddColumn, setTableToAddColumn] = useState(null);
  const [databaseToAddColumn, setDatabaseToAddColumn] = useState(null);
  const [removeColumnPopupVisible, setRemoveColumnPopupVisible] = useState(false);
  const [tableToRemoveColumn, setTableToRemoveColumn] = useState(null);
  const [databaseToRemoveColumn, setDatabaseToRemoveColumn] = useState(null);
  const [selectedColumnToRemove, setSelectedColumnToRemove] = useState(null);
  const { setViewResults } = useResults();
  const [tableColumns, setTableColumns] = useState({});
  const [columnCountsVisible, setColumnCountsVisible] = useState({});
  const [loading, setLoading] = useState(false);
  const [createTable, setCreateTable] = useState(false);

  const handleCreateTableClick = () => {
    if (!selectedDatabase) {
      toast.error("Please select a database first to create a table.");
      return;
    }
    
    setDatabaseToAddTable(selectedDatabase);
    setIsCreateTablePopupVisible(true);
  };

  const handleColumnCountClick = (key) => {
    setColumnCountsVisible((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleCloseCreateTablePopup = () => {
    setIsCreateTablePopupVisible(false);
  };

  const handleTableCreated = async () => {
    await fetchDatabases();
    
    if (selectedDatabase && sectionsOpen.openDatabaseId) {
      setTimeout(() => {
        setDatabaseLinks((prevLinks) => {
          const db = prevLinks.find((db) => db.label === selectedDatabase);
          if (db && db.tablesLoaded) {
            const updatedLinks = prevLinks.map((d) =>
              d.id === db.id ? { ...d, tablesLoaded: false } : d
            );
            fetchTablesForDatabase(db.id, selectedDatabase);
            return updatedLinks;
          }
          return prevLinks;
        });
      }, 100);
    }
  };

  const fetchTablesForDatabase = async (databaseId, databaseName) => {
    try {
      const { data: tablesData, error: tablesError } = await getTables(
        resourceId,
        systemUserId,
        databaseName
      );
      
      if (tablesError) {
        setDatabaseLinks((prevLinks) =>
          prevLinks.map((db) =>
            db.id === databaseId
              ? { ...db, tables: [], tableCount: 0, tablesLoaded: true }
              : db
          )
        );
        return;
      }
      
      const tableNames = tablesData.tables
        ? tablesData.tables.map((table) =>
            Array.isArray(table) ? table[0] : table
          )
        : [];
      
      setDatabaseLinks((prevLinks) =>
        prevLinks.map((db) =>
          db.id === databaseId
            ? {
                ...db,
                tables: tableNames,
                tableCount: tableNames.length,
                tablesLoaded: true,
              }
            : db
        )
      );
    } catch (error) {
      setError(error.message);
      setDatabaseLinks((prevLinks) =>
        prevLinks.map((db) =>
          db.id === databaseId
            ? { ...db, tables: [], tableCount: 0, tablesLoaded: true }
            : db
        )
      );
    }
  };

  const fetchDatabases = async () => {
    try {
      const { data, error } = await getDatabases(resourceId, systemUserId);
      if (error) {
        throw new Error(error);
      }
      
      const databasesWithLinks = data.databases.map((db, index) => ({
        id: index.toString(),
        label: Array.isArray(db) ? db[0] : db,
        tables: [],
        tableCount: 0,
        tablesLoaded: false,
      }));
      
      setDatabaseLinks(databasesWithLinks);
      setDatabaseCount(data.count);
    } catch (error) {
      setError(error.message);
    }
  };
  useEffect(() => {
    fetchDatabases();
  }, []);

  useEffect(() => {
    if (selectedDatabase && databaseLinks.length > 0) {
      const db = databaseLinks.find((db) => db.label === selectedDatabase);
      if (db && activeDatabaseId !== db.id) {
        prevActiveDatabaseIdRef.current = activeDatabaseId;
        setActiveDatabaseId(db.id);
      }
    }
  }, [selectedDatabase, databaseLinks]);

  const handleMouseDown = (event) => {
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (event) => {
    if (sidebarRef.current) {
      document.body.style.userSelect = "none";
      const sidebarRect = sidebarRef.current.getBoundingClientRect();
      const newWidth = event.clientX - sidebarRect.left;

      if (newWidth >= MIN_WIDTH_PX && newWidth <= MAX_WIDTH_PX) {
        sidebarRef.current.style.width = `${newWidth}px`;
      }
    }
  };

  const handleMouseUp = () => {
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  const handleSectionClick = (section) => {
    setSectionsOpen((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const handleDatabaseClick = (databaseId) => {
    const isOpening = sectionsOpen.openDatabaseId !== databaseId;
    
    setSectionsOpen((prevState) => ({
      ...prevState,
      openDatabaseId: isOpening ? databaseId : null,
    }));
    setActiveDatabaseId((prevState) =>
      prevState === databaseId ? null : databaseId
    );
    const db = databaseLinks.find((db) => db.id === databaseId);
    if (db) {
      const dbLabel = Array.isArray(db.label) ? db.label[0] : db.label;
      setSelectedDatabase(dbLabel);
      
      if (isOpening && !db.tablesLoaded) {
        fetchTablesForDatabase(databaseId, dbLabel);
      }
    }
  };

  const handleTableCountClick = (dbId) => {
    setSectionsOpen((prevState) => ({
      ...prevState,
      openTables: prevState.openTables === dbId ? null : dbId,
    }));
    setActiveTableCount((prevState) => (prevState === dbId ? null : dbId));
    setTableCountsVisible((prevState) => ({
      ...prevState,
      [dbId]: prevState[dbId] === undefined ? true : !prevState[dbId],
    }));
    if (activeTableCount !== dbId) {
      setActiveTable(null);
    }
  };

  const handleTableClick = async (tableName, dbId) => {
    const tableNameStr = Array.isArray(tableName) ? tableName[0] : tableName;
    const key = `${dbId}.${tableNameStr}`;

    setActiveTable(tableNameStr);
    setSectionsOpen((prevState) => ({
      ...prevState,
      openTableId: prevState.openTableId === key ? null : key,
    }));
    if (!tableColumns[key]) {
      const dbObj = databaseLinks.find((db) => db.id === dbId);
      const databaseName = Array.isArray(dbObj?.label) ? dbObj.label[0] : dbObj?.label;

      if (databaseName) {
        const { data, error } = await getColumns(
          resourceId,
          systemUserId,
          databaseName,
          tableNameStr
        );
        if (error) {
          setError(`Failed to fetch columns: ${error}`);
        } else if (data && data.columns) {
          const columnNames = data.columns.map(col => Array.isArray(col) ? col[0] : col);
          setTableColumns((prev) => ({
            ...prev,
            [key]: columnNames,
          }));
        }
      }
    }
  };

  const handleColumnClick = (columnName, tableName, dbId) => {
    setActiveColumn(columnName);
  };

  const handleContextMenu = (event, type, dbId, tableName, columnName) => {
    event.preventDefault();
    setContextMenu({
      visible: true,
      x: event.clientX,
      y: event.clientY,
      type,
      dbId,
      tableName,
      columnName,
    });
  };

  const handleContextMenuOption = async (option) => {
    if (option === "Create Database") {
      setCreateDatabasePopupVisible(true);
    } else if (option === "Refresh") {
      await fetchDatabases();
    } else if (option === "Create Table") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db) {
        const dbLabel = Array.isArray(db.label) ? db.label[0] : db.label;
        setDatabaseToAddTable(dbLabel);
        setIsCreateTablePopupVisible(true);
      }
    } else if (option === "Drop") {
      setIsCreateTablePopupVisible(true);
    } else if (option === "Drop Database") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db) {
        const dbLabel = Array.isArray(db.label) ? db.label[0] : db.label;
        setDatabaseToDrop(dbLabel);
        setDropDatabasePopupVisible(true);
      }
    } else if (option === "Rename Database") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db) {
        const dbLabel = Array.isArray(db.label) ? db.label[0] : db.label;
        setCurrentDatabaseName(dbLabel);
        setNewDatabaseName(dbLabel);
        setRenameDatabasePopupVisible(true);
      }
    } else if (option === "Export") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db && contextMenu.tableName) {
        const databaseName = Array.isArray(db.label) ? db.label[0] : db.label;
        const tableName = Array.isArray(contextMenu.tableName) ? contextMenu.tableName[0] : contextMenu.tableName;
        try {
          const { blob, message, error } = await exportTable(
            resourceId,
            systemUserId,
            databaseName,
            tableName
          );

          if (error) {
            setError(`Export failed: ${error}`);
            return;
          }

          if (blob) {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${tableName}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          }
        } catch (error) {
          setError(`Export failed: ${error.message}`);
        }
      } else {
        toast.error("No table selected for export");
      }
    } else if (option === "Import") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db && contextMenu.tableName) {
        const dbLabel = Array.isArray(db.label) ? db.label[0] : db.label;
        setImportDatabaseName(dbLabel);
        setImportTableName(contextMenu.tableName);
        setImportDataPopupVisible(true);
      }
    } else if (option === "Backup Database") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);

      if (db) {
        const databaseName = Array.isArray(db.label) ? db.label[0] : db.label;

        try {
          const { success, error } = await backupDatabase(
            resourceId,
            systemUserId,
            databaseName
          );
          if (!success) {
            setError(`Backup failed: ${error}`);
            return;
          }
          toast.success(
            "Backup process initiated successfully. Please check your downloads folder for the backup file."
          );
        } catch (error) {
          setError(`Backup failed: ${error.message}`);
        }
      } else {
        toast.error("No database selected for backup");
      }
    } else if (option === "Backup Table") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db) {
        const databaseName = Array.isArray(db.label) ? db.label[0] : db.label;
        const tableName = Array.isArray(contextMenu.tableName)
          ? contextMenu.tableName[0]
          : contextMenu.tableName;
        try {
          const { success, error } = await backupTable(
            resourceId,
            systemUserId,
            databaseName,
            tableName
          );
          if (!success) {
            setError(`Backup failed: ${error}`);
            return;
          }
          toast.success(
            "Backup process initiated successfully. Please check your downloads folder for the backup file."
          );
        } catch (error) {
          setError(`Backup failed: ${error.message}`);
        }
      } else {
        toast.error("No database selected for backup");
      }
    } else if (option === "Truncate Table") {
      const tableName = Array.isArray(contextMenu.tableName)
        ? contextMenu.tableName[0]
        : contextMenu.tableName;
      setTableToTruncate(tableName);
      setTruncateDataPopupVisible(true);
    } else if (option === "Add Column") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db && contextMenu.tableName) {
        const databaseName = Array.isArray(db.label) ? db.label[0] : db.label;
        const tableName = Array.isArray(contextMenu.tableName)
          ? contextMenu.tableName[0]
          : contextMenu.tableName;
        setTableToAddColumn(tableName);
        setDatabaseToAddColumn(databaseName);
        setAddColumnPopupVisible(true);
      }
    } else if (option === "Remove Column") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db && contextMenu.tableName) {
        const databaseName = Array.isArray(db.label) ? db.label[0] : db.label;
        const tableName = Array.isArray(contextMenu.tableName)
          ? contextMenu.tableName[0]
          : contextMenu.tableName;
        
        setTableToRemoveColumn(tableName);
        setDatabaseToRemoveColumn(databaseName);
        
        if (contextMenu.columnName) {
          const columnName = Array.isArray(contextMenu.columnName) 
            ? contextMenu.columnName[0] 
            : contextMenu.columnName;
          setSelectedColumnToRemove(columnName);
        } else {
          setSelectedColumnToRemove(null);
        }
        
        setRemoveColumnPopupVisible(true);
      }
    } else if (option === "Drop Table") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db) {
        const tableName = Array.isArray(contextMenu.tableName)
          ? contextMenu.tableName[0]
          : contextMenu.tableName;
        setDropTableName(tableName);
        setDropTableNameDatabase(db.label);
        setDropTablePopupVisible(true);
      }
    } else if (option === "Rename Table") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db && contextMenu.tableName) {
        const databaseName = Array.isArray(db.label) ? db.label[0] : db.label;
        const tableName = Array.isArray(contextMenu.tableName)
          ? contextMenu.tableName[0]
          : contextMenu.tableName;
        setCurrentTableName(tableName);
        setNewTableName(tableName);
        setDatabaseToRenameTable(databaseName);
        setRenameTablePopupVisible(true);
      }
    } else if (option === "Restore Table") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db && contextMenu.tableName) {
        const databaseName = Array.isArray(db.label) ? db.label[0] : db.label;
        const tableName = Array.isArray(contextMenu.tableName)
          ? contextMenu.tableName[0]
          : contextMenu.tableName;
        setTableToRestore(tableName);
        setDatabaseToRestoretable(databaseName);
        setRestoreTablePopupVisible(true);
      }
    } else if (option === "Restore Database") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db) {
        const databaseName = Array.isArray(db.label) ? db.label[0] : db.label;
        setRestoreDatabasePopupVisible(true);
        setCurrentDatabaseName(databaseName);
      }
    } else if (option === "View Data") {
      const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
      if (db) {
        const viewDbName = Array.isArray(db.label) ? db.label[0] : db.label;
        const viewTableName = Array.isArray(contextMenu.tableName) ? contextMenu.tableName[0] : contextMenu.tableName;
        const result = await viewTableData(
          resourceId,
          systemUserId,
          viewDbName,
          viewTableName
        );
        if (result.error) {
          toast.error(`Error: ${result.error}`);
        } else {
          setViewResults({
            databaseName: viewDbName,
            tableName: viewTableName,
            data: result.data.data,
            columns: result.data.columns,
            query: result.data.query,
          });
        }
      }
    }
    setContextMenu({ ...contextMenu, visible: false });
  };

  const handleDatabaseDrop = async () => {
    try {
      if (databaseToDrop) {
        const { data, error } = await dropDatabase(
          resourceId,
          systemUserId,
          databaseToDrop,
          resourceAccessID
        );
        if (error) {
          setError(error.message);
        } else {
                await fetchDatabases();
      
      if (triggerQueryRefresh) {
        setTimeout(() => {
          triggerQueryRefresh();
        }, 500);
      }
      
      handleCloseDropDatabasePopup();
        }
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const fetchColumnsForTable = async (databaseName, tableName, dbId) => {
    const tableNameStr = Array.isArray(tableName) ? tableName[0] : tableName;
    const key = `${dbId}.${tableNameStr}`;
    
    try {
      const { data, error } = await getColumns(
        resourceId,
        systemUserId,
        databaseName,
        tableNameStr
      );
      if (error) {
        setError(`Failed to fetch columns: ${error}`);
        return;
      }
      if (data && data.columns) {
        const columnNames = data.columns.map(col => Array.isArray(col) ? col[0] : col);
        setTableColumns((prev) => ({
          ...prev,
          [key]: columnNames,
        }));
      }
    } catch (error) {
      setError(`Failed to fetch columns: ${error.message}`);
    }
  };

  const handleAddColumn = async (
    resourceId,
    systemUserId,
    appType,
    databaseName,
    tableName,
    columns
  ) => {
    try {
      const successMessages = [];
      for (const column of columns) {
        const response = await addColumnToTable(
          resourceId,
          systemUserId,
          appType,
          databaseName,
          tableName,
          column.name,
          column.type,
          column.length,
          resourceAccessID
        );
        if (response.error) {
          throw new Error(response.error);
        }
        if (response.data && response.data.message) {
          successMessages.push(response.data.message);
        }
      }
      handleCloseAddColumnPopup();
      
      if (successMessages.length > 0) {
        if (successMessages.length === 1) {
          toast.success(successMessages[0]);
        } else {
          toast.success(`${successMessages.length} columns added successfully`);
        }
      }
      
      const db = databaseLinks.find((db) => {
        const dbLabel = Array.isArray(db.label) ? db.label[0] : db.label;
        return dbLabel === databaseName;
      });
      
      const tableNameStr = Array.isArray(tableName) ? tableName[0] : tableName;
      const key = db ? `${db.id}.${tableNameStr}` : null;
      
      if (key) {
        setTableColumns((prev) => {
          const updated = { ...prev };
          delete updated[key];
          return updated;
        });
      }
      
      await fetchDatabases();
      
      if (key && sectionsOpen.openTableId === key) {
        setTimeout(() => {
          setDatabaseLinks((currentLinks) => {
            const updatedDb = currentLinks.find((db) => {
              const dbLabel = Array.isArray(db.label) ? db.label[0] : db.label;
              return dbLabel === databaseName;
            });
            if (updatedDb) {
              fetchColumnsForTable(databaseName, tableName, updatedDb.id);
            }
            return currentLinks; 
          });
        }, 100);
      }
      
      if (triggerQueryRefresh) {
        setTimeout(() => {
          triggerQueryRefresh();
        }, 500);
      }
    } catch (error) {
      setError(error.message);
      if (error.message) {
        const errorMsg = typeof error.message === 'string' 
          ? error.message 
          : error.message.message 
            ? (Array.isArray(error.message.message) ? error.message.message[0] : error.message.message)
            : 'Failed to add column';
        toast.error(errorMsg);
      }
    }
  };

  const handleRemoveColumn = async (
    resourceId,
    systemUserId,
    databaseName,
    tableName,
    columnNames
  ) => {
    try {
      for (const columnName of columnNames) {
        const response = await dropColumnFromTable(
          resourceId,
          systemUserId,
          databaseName,
          tableName,
          columnName,
          databaseInfo,
          resourceAccessID
        );
        if (response.error) {
          throw new Error(response.error);
        }
      }
            handleCloseRemoveColumnPopup();
      
      if (columnNames.length === 1) {
        toast.success(`Column "${columnNames[0]}" removed successfully`);
      } else {
        toast.success(`${columnNames.length} columns removed successfully`);
      }

      const db = databaseLinks.find((db) => {
        const dbLabel = Array.isArray(db.label) ? db.label[0] : db.label;
        return dbLabel === databaseName;
      });
      
      const tableNameStr = Array.isArray(tableName) ? tableName[0] : tableName;
      const key = db ? `${db.id}.${tableNameStr}` : null;
      
      if (key) {
        setTableColumns((prev) => {
          const updated = { ...prev };
          delete updated[key];
          return updated;
        });
      }

      await fetchDatabases();

      if (key && sectionsOpen.openTableId === key) {
        setTimeout(() => {
          setDatabaseLinks((currentLinks) => {
            const updatedDb = currentLinks.find((db) => {
              const dbLabel = Array.isArray(db.label) ? db.label[0] : db.label;
              return dbLabel === databaseName;
            });
            if (updatedDb) {
              fetchColumnsForTable(databaseName, tableName, updatedDb.id);
            }
            return currentLinks;
          });
        }, 100);
      }

      if (triggerQueryRefresh) {
        setTimeout(() => {
          triggerQueryRefresh();
        }, 500);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const handleRestoreDatabase = async () => {
    try {
      await fetchDatabases();
        if (triggerQueryRefresh) {
        setTimeout(() => {
          triggerQueryRefresh();
        }, 500);
      }
      
      setRestoreDatabasePopupVisible(false);
      setError("");
    } catch (error) {
      setError(error.message || "Error while refreshing the database list.");
    }
  };

  const handleRenameTable = async (newTableName) => {
    try {
      const db = databaseLinks.find((db) => {
        return Array.isArray(db.label)
          ? db.label.includes(databaseToRenameTable)
          : db.label === databaseToRenameTable;
      });
      if (!db) {
        throw new Error(
          `Database with label "${databaseToRenameTable}" not found.`
        );
      }
      const databaseName = Array.isArray(db.label) ? db.label[0] : db.label;
      const oldTableName = Array.isArray(currentTableName)
        ? currentTableName[0]
        : currentTableName;
      const finalNewTableName = Array.isArray(newTableName)
        ? newTableName[0]
        : newTableName;
      const response = await renameTable(
        resourceId,
        systemUserId,
        databaseName,
        oldTableName,
        finalNewTableName,
        resourceAccessID
      );
      if (response.error) {
        throw new Error(response.error);
      }
      setRenameTablePopupVisible(false);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleRenameDatabase = async () => {
    try {
      await renameDatabase(
        resourceId,
        systemUserId,
        currentDatabaseName,
        newDatabaseName,
        resourceAccessID
      );
      await fetchDatabases();
      setRenameDatabasePopupVisible(false);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleRestoreTable = async () => {
    try {
      await fetchDatabases();
      
      if (triggerQueryRefresh) {
        setTimeout(() => {
          triggerQueryRefresh();
        }, 500);
      }
      
      setRestoreTablePopupVisible(false);
      setError("");
    } catch (error) {
      setError(error.message || "Error while refreshing the database list.");
    }
  };

  const handleTableDrop = async () => {
    try {
      if (dropTableName && dropTableNameDatabase) {
        await dropTable(
          resourceId,
          systemUserId,
          dropTableNameDatabase,
          dropTableName,
          resourceAccessID
        );
        handleCloseDropTablePopup();
      } else {
        setError("Table name and database name must be provided.");
      }
    } catch (error) {
      setError(error.message || "An error occurred while dropping the table.");
    }
  };

  const handleCloseDropTablePopup = () => {
    setDropTablePopupVisible(false);
  };

  const handleCloseCreateDatabasePopup = () => {
    setCreateDatabasePopupVisible(false);
    setFormData("");
  };

  const handleCloseDropDatabasePopup = () => {
    setDropDatabasePopupVisible(false);
  };

  const handleDatabaseCreate = async (dbName) => {
    try {
      const response = await createDatabase(
        resourceId,
        systemUserId,
        dbName,
        resourceAccessID
      );
      
      if (response.error) {
        throw new Error(response.error);
      }
      
      await fetchDatabases();
      
      setSelectedDatabase(dbName);
      
      if (triggerQueryRefresh) {
        setTimeout(() => {
          triggerQueryRefresh();
        }, 500);
      }
      
      handleCloseCreateDatabasePopup();
    } catch (error) {
      setError(error.message);
    }
  };

  const handleCloseAddColumnPopup = () => {
    setAddColumnPopupVisible(false);
  };
  
  const handleCloseRemoveColumnPopup = () => {
    setRemoveColumnPopupVisible(false);
    setSelectedColumnToRemove(null);
  };
  
  const handleCloseImportDataPopup = () => {
    setImportDataPopupVisible(false);
  };

  const handleImportDataSave = () => {
    handleCloseImportDataPopup();
  };

  const handleCloseTruncateDataPopup = () => {
    setTruncateDataPopupVisible(false);
  };
  const handleCloseRenameTablePopup = () => {
    setIsRenameTablePopupVisible(false);
  };

  const handleRenameTableSave = (newName) => {
    handleCloseRenameTablePopup();
  };

  const handleCloseRenameDatabasePopup = () => {
    setIsRenameDatabasePopupVisible(false);
  };

  const handleRenameDatabaseSave = (newName) => {
    handleCloseRenameDatabasePopup();
  };

  const handleCloseRestoreTablePopup = () => {
    setIsRestoreTablePopupVisible(false);
  };

  const handleTruncateDataSave = async () => {
    handleCloseTruncateDataPopup();
  };

  const handleClickOutside = useCallback(
    (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setContextMenu({ ...contextMenu, visible: false });
      }
    },
    [contextMenu]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setContextMenu({ ...contextMenu, visible: false });
        handleCloseTruncateDataPopup();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [contextMenu]);

  return (
    <div className="database-gui-sidebar" ref={sidebarRef}>
      <div className="database-gui-resize-handle" onMouseDown={handleMouseDown}></div>
      <div className="database-gui-sidebar-content">
        <div className="database-gui-database-type-header">
          <a
            href="#"
            className="database-gui-sidebar-container"
              onClick={() => handleSectionClick("databases")}
            onContextMenu={(event) => event.preventDefault()}
            title={databaseInfo}
          >
            {databaseInfo === "MySQL" && (
              <GrMysql
                size={24}
                className="database-gui-sidebar-icon-database"
                style={{
                  color: "#3263a0",
                  marginLeft: "10px",
                }}
              />
            )}
            {databaseInfo === "PostgreSQL" && (
              <BiLogoPostgresql
                size={24}
                className="database-gui-sidebar-icon-database"
                style={{
                  color: "#32638B",
                  marginLeft: "10px",
                }}
              />
            )}
            {databaseInfo === "MSSQL" && (
              <DiMsqlServer
                size={24}
                className="database-gui-sidebar-icon-database"
                style={{
                  color: "#af0b0b",
                  marginLeft: "10px",
                }}
              />
            )}
            <span style={{ fontWeight: "900", fontSize: "16px" }}>
              {databaseInfo}
            </span>{" "}
          </a>
        </div>
        {sectionsOpen && (
          <div className="database-gui-database-section-container">
            <DatabaseSection
              sectionsOpen={sectionsOpen}
              handleSectionClick={handleSectionClick}
              handleContextMenu={handleContextMenu}
              databaseCount={databaseCount}
              databaseLinks={databaseLinks}
              activeDatabaseId={activeDatabaseId}
              handleDatabaseClick={handleDatabaseClick}
              activeTableCount={activeTableCount}
              handleTableCountClick={handleTableCountClick}
              tableCountsVisible={tableCountsVisible}
              handleTableClick={handleTableClick}
              activeTable={activeTable}
              activeColumn={activeColumn}
              handleColumnClick={handleColumnClick}
              tableColumns={tableColumns}
              columnCountsVisible={columnCountsVisible}
              handleColumnCountClick={handleColumnCountClick}
              selectedDatabase={selectedDatabase}
              setSelectedDatabase={setSelectedDatabase}
            />
          </div>
        )}

        {contextMenu.visible && contextMenu.type !== "columns" && (
          <CustomContextMenu
            ref={menuRef}
            x={contextMenu.x}
            y={contextMenu.y}
            onOptionClick={handleContextMenuOption}
            contextMenuType={contextMenu.type}
          />
        )}

        {createDatabasePopupVisible && (
          (() => {
            return (
              <DatabaseCreatePopup
                visible={createDatabasePopupVisible}
                onClose={handleCloseCreateDatabasePopup}
                onSave={handleDatabaseCreate}
                formData={formData}
                setFormData={setFormData}
                appId={resourceId}
                systemUserId={systemUserId}
                databaseInfo={databaseInfo}
              />
            );
          })()
        )}

        {isCreateTablePopupVisible && (
          <CreateTablePopup
            onClose={handleCloseCreateTablePopup}
            databaseName={databaseToAddTable || selectedDatabase}
            appId={resourceId}
            systemUserId={systemUserId}
            loading={loading}
            setLoading={setLoading}
            setCreateTable={setCreateTable}
            databaseInfo={databaseInfo}
            onTableCreated={handleTableCreated}
            resourceAccessID={resourceAccessID}
          />
        )}

        {dropDatabasePopupVisible && (
            <DatabaseDropPopup
              visible={dropDatabasePopupVisible}
              onClose={handleCloseDropDatabasePopup}
              onSave={handleDatabaseDrop}
              databaseName={databaseToDrop}
              resourceId={resourceId}
              systemUserId={systemUserId}
              databaseInfo={databaseInfo}
            />
        )}

        {dropTablePopupVisible && (
          <TableDropPopup
            visible={dropTablePopupVisible}
            onClose={handleCloseDropTablePopup}
            onSave={handleTableDrop}
            databaseName={dropTableNameDatabase}
            tableName={dropTableName}
            appId={resourceId}
            systemUserId={systemUserId}
            databaseInfo={databaseInfo}
          />
        )}

        {importDataPopupVisible && (
          <ImportDataInTable
            visible={importDataPopupVisible}
            onClose={handleCloseImportDataPopup}
            onSave={handleImportDataSave}
            tableName={importTableName}
            dbName={importDatabaseName}
            appId={resourceId}
            systemUserId={systemUserId}
            databaseInfo={databaseInfo}
          />
        )}

        {truncateDataPopupVisible && (
          <TruncateDataPopup
            visible={truncateDataPopupVisible}
            onClose={handleCloseTruncateDataPopup}
            onSave={handleTruncateDataSave}
            dbName={
              (() => {
                const db = databaseLinks.find((db) => db.id === contextMenu.dbId);
                return Array.isArray(db?.label) ? db.label[0] : db?.label;
              })()
            }
            tableName={tableToTruncate}
            appId={resourceId}
            systemUserId={systemUserId}
            resourceAccessID={resourceAccessID}
            databaseInfo={databaseInfo}
          />
        )}
        {addColumnPopupVisible && (
            <AddColumnPopup
              visible={addColumnPopupVisible}
              onClose={handleCloseAddColumnPopup}
              onSave={handleAddColumn}
              tableName={tableToAddColumn}
              resourceId={resourceId}
              systemUserId={systemUserId}
              appType={databaseInfo}
              databaseName={databaseToAddColumn}
              databaseInfo={databaseInfo}
            />
        )}
        {removeColumnPopupVisible && (
            <RemoveColumnPopup
              visible={removeColumnPopupVisible}
              onClose={handleCloseRemoveColumnPopup}
              onSave={handleRemoveColumn}
              tableName={tableToRemoveColumn}
              resourceId={resourceId}
              systemUserId={systemUserId}
              databaseName={databaseToRemoveColumn}
              databaseInfo={databaseInfo}
              availableColumns={(() => {
                const key = `${contextMenu.dbId}.${tableToRemoveColumn}`;
                return tableColumns[key] || [];
              })()}
              selectedColumn={selectedColumnToRemove}
              loading={loading}
              setLoading={setLoading}
            />
        )}
        {renameTablePopupVisible && (
          <RenameTablePopup
            visible={renameTablePopupVisible}
            onClose={() => setRenameTablePopupVisible(false)}
            onSave={handleRenameTable}
            currentName={currentTableName}
            resourceId={resourceId}
            systemUserId={systemUserId}
            dbName={databaseToRenameTable}
            databaseInfo={databaseInfo}
          />
        )}
        {restoreTablePopupVisible && (
          <RestoreTablePopup
            visible={restoreTablePopupVisible}
            onClose={() => setRestoreTablePopupVisible(false)}
            onRestore={handleRestoreTable}
            dbName={databasetorestoretable}
            tableName={tableToRestore}
            appId={resourceId}
            systemUserId={systemUserId}
            databaseInfo={databaseInfo}
            loading={false}
          />
        )}

        {restoreDatabasePopupVisible && (
          <RestoreDatabasePopup
            visible={restoreDatabasePopupVisible}
            onClose={() => setRestoreDatabasePopupVisible(false)}
            onRestore={handleRestoreDatabase}
            dbName={currentDatabaseName}
            appId={resourceId}
            systemUserId={systemUserId}
            databaseInfo={databaseInfo}
            loading={restoreLoading}
            setLoading={setRestoreLoading}
          />
        )}

        {renameDatabasePopupVisible && (
          <RenameDatabasePopup
            visible={renameDatabasePopupVisible}
            onClose={() => setRenameDatabasePopupVisible(false)}
            onSave={handleRenameDatabase}
            currentName={currentDatabaseName}
            newName={newDatabaseName}
            setNewName={setNewDatabaseName}
            systemUserId={systemUserId}
            resourceId={resourceId}
            databaseInfo={databaseInfo}
          />
        )}
      </div>
    </div>
  );
};

export default SideBar;
